export const FEATURE_FLAGS = {
  complianceLaboral: false,
  digitalDisconnection: false,
  // 2026-09-22: botón "Novedades" del header oculto temporalmente para todos los usuarios a
  // petición de producto; el contenido (COMPLITY_NEWS) ya estaba vacío, sin datos que perder.
  whatsNew: false,
} as const;

export type FeatureFlagKey = keyof typeof FEATURE_FLAGS;
